import { NgModule }             from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { HomeComponent } from './home/home.component'; 
import { HowItWorksComponent } from './others/how-it-works/how-it-works.component';
import { ForgotPasswordComponent } from './others/forgot-password/forgot-password.component';
import { AnonnymousDonationComponent } from './others/anonnymous-donation/anonnymous-donation.component';
import { SearchComponent } from './others/search/search.component';
import { PledgeYourSupportComponent } from './others/pledge-your-support/pledge-your-support.component';
import { ImpactedLivesPageComponent } from './others/impacted-lives-page/impacted-lives-page.component';
import { ImpactedLivesDetailComponent } from './others/impacted-lives-detail/impacted-lives-detail.component';
import { FaqsComponent } from './others/faqs/faqs.component';
import { SitemapComponent } from './others/sitemap/sitemap.component';

 

const approutes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'how-it-works', component: HowItWorksComponent }, 
  { path: 'forgot-password', component: ForgotPasswordComponent }, 
  { path: 'anonymous-donation', component: AnonnymousDonationComponent }, 
  { path: 'pledge-your-support', component: PledgeYourSupportComponent },  
  { path: 'faq',  component: FaqsComponent },
  { path: 'sitemap',  component: SitemapComponent },
  { path: 'impacted-lives', component: ImpactedLivesPageComponent },
  { path: 'impacted-lives/:type', component: ImpactedLivesPageComponent },
  { path: 'impacted-lives/:id', component: ImpactedLivesDetailComponent },
  { path: 'impacted-lives/:id/:name', component: ImpactedLivesDetailComponent },
  { path: 'search', component: SearchComponent }, 
  { path: 'search/:key', component: SearchComponent }, 
  { path: 'donate', loadChildren: './donate/donate.module#DonateModule'}, 
  { path: 'fundraising', loadChildren: './donate/donate.module#DonateModule'},
  { path: 'payment',  loadChildren: './payment/payment.module#PaymentModule' },
  { path: 'about',  loadChildren: './about/about.module#AboutModule' },
  { path: 'account',  loadChildren: './account/account.module#AccountModule' },
  { path: 'my-fundraisers',  loadChildren: './fundraise/fundraise.module#FundraiseModule' }
];

@NgModule({
  imports: [ RouterModule.forRoot(approutes, {preloadingStrategy: PreloadAllModules}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
